//#region src/modules/core/data/mutation.ts
var markAllViewed = async (instance) => {
	return (await instance.get("/api/notification/markAllViewed")).status === 200;
};
var changeLocale = async (instance, idioma) => {
	return (await instance.post("/api/user/changeLocale", idioma, { headers: { "Content-Type": "text/plain" } })).data;
};
var setSeen = async (instance, id) => {
	return (await instance.post("/api/onboarding/seen", id, { headers: { "Content-Type": "text/plain" } })).status === 200;
};
//#endregion
export { changeLocale, markAllViewed, setSeen };
